<rez-json-form [(data)]="response" [uiSchema]="uiSchema" [schema]="schema">
</rez-json-form>

